// extracted by mini-css-extract-plugin
export default {"flashcard":"FlashCard_flashcard__KxK5b","description":"FlashCard_description__WCSmQ","flag":"FlashCard_flag__+Ya0X","reverse-button":"FlashCard_reverse-button__tod5C"};